import { render, staticRenderFns } from "./KarmaCategoryAddForm.vue?vue&type=template&id=b3302c30&scoped=true&"
import script from "./KarmaCategoryAddForm.vue?vue&type=script&lang=js&"
export * from "./KarmaCategoryAddForm.vue?vue&type=script&lang=js&"
import style0 from "./KarmaCategoryAddForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./KarmaCategoryAddForm.vue?vue&type=style&index=1&id=b3302c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3302c30",
  null
  
)

export default component.exports